import React from 'react'
import { Dd } from './StyledDlElements'
import { AccountDetails } from '../../../types'
import { amountFormatter } from '../../../utils/formatter'
import { TopCardItem } from '../TopCardItem'

export const CurrentBalanceTopCard: React.FC<{ account: AccountDetails }> = ({
  account,
}) => {
  return (
    <TopCardItem
      title="CURRENT BALANCE"
      dejargContent="Current Balance includes deposits that have posted but are not yet available. Pending withdrawals aren't deducted from this amount."
    >
      <Dd
        size="lg"
        data-testId="current-balance"
        color={account.currentBalancePvtEncrypt < 0 ? 'error' : 'slate-5'}
      >
        {amountFormatter.format(account.currentBalancePvtEncrypt)}
      </Dd>
    </TopCardItem>
  )
}
